import { http } from 'utils'

// System mutation imports.

// System state.
const state = {}

// System state getters.
const getters = {}

// System actions.
const actions = {
  processTalentCsvImport (store, file) {
    let payload = new FormData()

    payload.append('csv', file)

    return http.post(`system/import_talent_csv`, payload)
  },

  processTalentCsvExport (store) {
    return http.get(`system/export_talent_csv`)
  }
}

// System state mutations.
const mutations = {}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
